"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _InputDateTime = _interopRequireDefault(require("01_core/components/select/InputDateTime"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _kansaReportActions = require("../kansaReportActions");
var _KansaReportEvaluationHeader = _interopRequireDefault(require("./components/KansaReportEvaluationHeader"));
var Yup = _interopRequireWildcard(require("yup"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査報告書評価登録画面
 */
function KansaReportEvaluationRegister(props) {
  var _info$entryStsCd, _entries$kinyuDate, _entries$kinyushaNm, _entries$comment, _entries$kinyuDate2, _errors$kinyuDate, _entries$kinyushaNm2, _errors$kinyushaNm, _entries$comment2, _errors$comment;
  const {
    intl,
    callAPI,
    setEntries,
    changeEntry,
    setRegister,
    resetRegister,
    openInfoBar,
    openConfirm,
    goMain,
    goRefer,
    clearEntries,
    checkDirty,
    openReport,
    entries,
    info,
    targetReport,
    dispContent,
    setDirty
  } = props;
  const shape = {
    entryStsCd: Yup.string().nullable(),
    kinyuDate: (0, _validationHelpers.dateOrEmptyStrict)(intl).concat((0, _validationHelpers.notFutureDateOrEmpty)(intl)).when('entryStsCd', (entryStsCd, schema) => String(entryStsCd) === String(_CodeConsts.CODE.KANSA_RP_EVSTS.CODE_3) ? schema.required(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_PLEASE_SELECT
    })) : schema),
    kinyushaNm: (0, _validationHelpers.optionalStringTrimMax)(intl, 60).when('entryStsCd', (entryStsCd, schema) => String(entryStsCd) === String(_CodeConsts.CODE.KANSA_RP_EVSTS.CODE_3) ? (0, _validationHelpers.requiredStringTrimMax)(intl, 60) : schema),
    comment: (0, _validationHelpers.optionalStringTrimMax)(intl, 500)
  };
  const defaultValues = {
    entryStsCd: (_info$entryStsCd = info === null || info === void 0 ? void 0 : info.entryStsCd) !== null && _info$entryStsCd !== void 0 ? _info$entryStsCd : '',
    kinyuDate: (_entries$kinyuDate = entries === null || entries === void 0 ? void 0 : entries.kinyuDate) !== null && _entries$kinyuDate !== void 0 ? _entries$kinyuDate : '',
    kinyushaNm: (_entries$kinyushaNm = entries === null || entries === void 0 ? void 0 : entries.kinyushaNm) !== null && _entries$kinyushaNm !== void 0 ? _entries$kinyushaNm : '',
    comment: (_entries$comment = entries === null || entries === void 0 ? void 0 : entries.comment) !== null && _entries$comment !== void 0 ? _entries$comment : ''
  };
  const {
    handleSubmit,
    setValue,
    formState,
    reset
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues,
    shape
  });
  const {
    errors
  } = formState;
  const didFetchRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
    if (didFetchRef.current) return;
    didFetchRef.current = true;
    const {
      kaishaSummary,
      kansaTgtNendo,
      hikansabumonKaishaCd,
      hikansabumonSoshikiCd
    } = targetReport;
    const editable = dispContent !== _kansaReportActions.CONTENTS.EV_REFER;
    callAPI(_APIs.KANSA_REPORT_EV_REFER, {
      kaishaSummary,
      kansaTgtNendo,
      hikansabumonKaishaCd,
      hikansabumonSoshikiCd,
      editable
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        var _info$entryStsCd2, _response$data$kinyuD, _response$data, _response$data$kinyus, _response$data2, _response$data$commen, _response$data3;
        setDirty && setDirty(false);
        setEntries(response.data);
        reset({
          entryStsCd: (_info$entryStsCd2 = info === null || info === void 0 ? void 0 : info.entryStsCd) !== null && _info$entryStsCd2 !== void 0 ? _info$entryStsCd2 : '',
          kinyuDate: (_response$data$kinyuD = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.kinyuDate) !== null && _response$data$kinyuD !== void 0 ? _response$data$kinyuD : '',
          kinyushaNm: (_response$data$kinyus = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.kinyushaNm) !== null && _response$data$kinyus !== void 0 ? _response$data$kinyus : '',
          comment: (_response$data$commen = (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.comment) !== null && _response$data$commen !== void 0 ? _response$data$commen : ''
        });
      }
    });
  }, [callAPI, setEntries, reset, targetReport, dispContent, info === null || info === void 0 ? void 0 : info.entryStsCd, setDirty]);
  (0, _react.useEffect)(() => {
    return () => {
      clearEntries();
    };
  }, [clearEntries]);
  const onChangeDate = (0, _react.useCallback)(value => {
    changeEntry('kinyuDate', value);
    setDirty && setDirty(true);
    setValue('kinyuDate', value, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [changeEntry, setValue, setDirty]);
  const onChangeKinyushaNm = (0, _react.useCallback)(value => {
    changeEntry('kinyushaNm', value);
    setDirty && setDirty(true);
    setValue('kinyushaNm', value, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [changeEntry, setValue, setDirty]);
  const onChangeComment = (0, _react.useCallback)(value => {
    changeEntry('comment', value);
    setDirty && setDirty(true);
    setValue('comment', value, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [changeEntry, setValue, setDirty]);
  const registerEntries = (0, _react.useCallback)(done => {
    callAPI(_APIs.KANSA_REPORT_EV_REGISTER, _objectSpread(_objectSpread({}, entries), {}, {
      hyokaCreStsCd: done ? _CodeConsts.CODE.KANSA_RP_EVSTS.CODE_3 : _CodeConsts.CODE.KANSA_RP_EVSTS.CODE_2
    })).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setDirty && setDirty(false);
        if (done) {
          goRefer(targetReport, dispContent);
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
            id: _labelConsts.LABEL.KANSA_REPORT_EVALUATION_TEMPORARILY_SAVED
          }));
          goMain(dispContent);
        }
      }
    });
  }, [callAPI, entries, goRefer, targetReport, dispContent, openInfoBar, intl, goMain, setDirty]);
  const onValid = (0, _react.useCallback)(data => {
    const done = String(data.entryStsCd) === String(_CodeConsts.CODE.KANSA_RP_EVSTS.CODE_3);
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
      id: done ? _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE : _labelConsts.LABEL.KANSA_TEMPORARILY_SAVE_CONFIRM_MESSAGE
    }), () => {
      registerEntries(done);
    });
  }, [openConfirm, intl, registerEntries]);
  const onInvalid = (0, _react.useCallback)(() => {
    resetRegister();
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [resetRegister, openInfoBar, intl]);
  const onClickTemporary = (0, _react.useCallback)(() => {
    setRegister(_CodeConsts.CODE.KANSA_RP_EVSTS.CODE_2);
    setValue('entryStsCd', _CodeConsts.CODE.KANSA_RP_EVSTS.CODE_2, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [setRegister, setValue]);
  const onClickRegister = (0, _react.useCallback)(() => {
    setRegister(_CodeConsts.CODE.KANSA_RP_EVSTS.CODE_3);
    setValue('entryStsCd', _CodeConsts.CODE.KANSA_RP_EVSTS.CODE_3, {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [setRegister, setValue]);
  const isDone = String(entries === null || entries === void 0 ? void 0 : entries.hyokaCreStsCd) === String(_CodeConsts.CODE.KANSA_RP_EVSTS.CODE_3);
  const returnBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    negative: true,
    autoWidth: true,
    onClick: () => {
      checkDirty(() => {
        goMain(dispContent);
      });
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
  }));
  const temporaryBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    submit: true,
    onClick: onClickTemporary
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_TEMPORARILY_SAVE
  }));
  const registerBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    submit: true,
    onClick: onClickRegister
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }));
  const withTempButton = [returnBtn, temporaryBtn, registerBtn];
  const noTempButton = [returnBtn, registerBtn];
  return info.ready ? /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_EVALUATION_REGISTER
    }),
    actions: isDone ? noTempButton : withTempButton,
    fixedWidth: true
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 1
  }, !entries ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_NO_DATA_TO_DISPLAY
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_KansaReportEvaluationHeader.default, {
    entries: entries
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 2
    },
    align: "right"
  }, /*#__PURE__*/_react.default.createElement(_CButton.default, {
    autoWidth: true,
    onClick: openReport
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_SHOW_REPORT
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KINYU_DATE
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: (_entries$kinyuDate2 = entries === null || entries === void 0 ? void 0 : entries.kinyuDate) !== null && _entries$kinyuDate2 !== void 0 ? _entries$kinyuDate2 : '',
    onChange: onChangeDate,
    name: 'kinyuDate',
    dateOnly: true,
    error: !!errors.kinyuDate,
    helperText: (_errors$kinyuDate = errors.kinyuDate) === null || _errors$kinyuDate === void 0 ? void 0 : _errors$kinyuDate.message
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KINYUSHA
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: (_entries$kinyushaNm2 = entries === null || entries === void 0 ? void 0 : entries.kinyushaNm) !== null && _entries$kinyushaNm2 !== void 0 ? _entries$kinyushaNm2 : '',
    onChange: onChangeKinyushaNm,
    maxLength: 60,
    error: !!errors.kinyushaNm,
    helperText: (_errors$kinyushaNm = errors.kinyushaNm) === null || _errors$kinyushaNm === void 0 ? void 0 : _errors$kinyushaNm.message
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_EV_COMMENT
    })
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: (_entries$comment2 = entries === null || entries === void 0 ? void 0 : entries.comment) !== null && _entries$comment2 !== void 0 ? _entries$comment2 : '',
    onChange: onChangeComment,
    multiline: true,
    rows: 10,
    maxLength: 500,
    error: !!errors.comment,
    helperText: (_errors$comment = errors.comment) === null || _errors$comment === void 0 ? void 0 : _errors$comment.message
  })))))))) : null;
}
const mapStateToProps = state => {
  return {
    dispContent: state.kansaReport.containerInfo.dispContent,
    previousContent: state.kansaReport.containerInfo.previousContent,
    targetReport: state.kansaReport.targetReport,
    info: state.kansaReport.evaluation,
    entries: state.kansaReport.evaluation.entries
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntries: entries => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_EV_ENTRIES](entries)),
    changeEntry: (key, value) => {
      dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_EV_ENTRY](key, value));
    },
    setRegister: value => {
      dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_EVALUATION_REGISTER](value));
    },
    resetRegister: () => {
      dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.RESET_EVALUATION_REGISTER]());
    },
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    goMain: previousContent => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_MAIN](previousContent)),
    goRefer: (entries, previousContent) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_EV_REFER](entries, previousContent)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    clearEntries: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CLEAR_EV_ENTRIES]()),
    setDirty: dirty => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_DIRTY](dirty))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CustomRouter.withRouter)((0, _CallAPI.withCallAPI)(KansaReportEvaluationRegister)))));